import { AddIcon, UserIcon } from 'asset/icons';
import React, { useState } from 'react'
import ShippingAgentModal from './modals/ShippingAgentModal';
import AddNetwork from 'component/addNetwork';
import { useSelector } from 'react-redux';
import useNetworkUsers from 'hooks/useNetworkUsers';

const AssignShippingAgent = ({
    isAgent,
    updateShippingLeg,
    leg,
    setSelectedUser,
    selectedUser,
    show,
    setShow,
    forFinance = false
}) => {
    const business = useSelector((state) => state.business);
        const {
            addNetworkModal,
            setAddNetworkModal,
            fetchSuppliers,
        } = useNetworkUsers();

       const handleFetchSuppliers = (businessId) => {
           fetchSuppliers("/v1/flex/users", {
               headers: { "x-business-id": businessId },
           });
       };
    return (
        <>
            <div>
                {forFinance ? (
                    <label className="mb-1 text-sm text-gray-70">Contract Employer</label>
                ) : (
                    <label
                        htmlFor=""
                        className="text-[14px] leading-[19.6px] font-medium	text-gray-10 mb-2"
                    >
                        Assign Clearing Agent
                    </label>
                )}
                <div
                    className={` h-[56px] border rounded-[8px] ${
                        isAgent ? "bg-gray-200 opacity-65" : "bg-white"
                    }`}
                    onClick={() => !isAgent && setShow(true)}
                >
                    <div
                        className={`pl-1 duration-200 transition cursor-pointer flex w-full items-center h-full rounded-[8px] ${
                            isAgent ? "" : "hover:bg-[#BFA6FF]/30"
                        }`}
                    >
                        <div
                            className={`flex items-center justify-center p-2 rounded-full size-8 bg-gray-100`}
                        >
                            <UserIcon className="text-base" />
                        </div>
                        <div className="w-full flex justify-between items-center text-md pl-[8px]">
                            <p className="text-sm text-gray-70">Add Clearing Agent</p>
                            <div className="w-[30px] h-full flex items-center justify-center">
                                <AddIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ShippingAgentModal
                show={show}
                setShow={setShow}
                updateShippingLeg={updateShippingLeg}
                leg={leg}
                setSelectedUser={setSelectedUser}
                selectedUser={selectedUser}
                addNetworkModal={addNetworkModal}
                setAddNetworkModal={setAddNetworkModal}
            />
            <AddNetwork
                refetchUser={() => {
                    handleFetchSuppliers(business?._id);
                    setShow(true);
                }}
                show={addNetworkModal}
                close={() => setAddNetworkModal(false)}
            />
        </>
    );
};


export default AssignShippingAgent